import React, { useContext } from "react";
import { Link } from "react-router-dom";
import FuncionesContext, {
  getAtributo,
} from "../../../context/FuncionesContext";
import { construirEnlace } from "../../../helper/funciones";

const Enlace = ({ data, cab, hijos, campokey, indiceData, id_elemento }) => {
  const { enviarAModal } = useContext(FuncionesContext);

  const e = getAtributo("enlace", data, cab);


  const enlaceConstruido = construirEnlace(data, cab);
  const enlace = enlaceConstruido.enlace_completo;

  if (cab.target === "modal") {
    return (
      <div
        onClick={() =>
          enviarAModal(enlaceConstruido.id_a, enlaceConstruido.params, {
            min_width_modal: cab.min_width_modal,
          })
        }
        id={id_elemento}
        className={`Listado_Switch_Enlace ${cab.className}`}
      >
        {renderContenido(cab, data, hijos)}
      </div>
    );
  }

  if (cab.target === "_blank") {
    return (
      <Ancla
        id_elemento={id_elemento}
        cab={cab}
        enlace={enlace}
        data={data}
        hijos={hijos}
        target={cab.target}
      />
    );
  }

  if (cab.target === "descarga") {
    const archivo_nombre =
      data[cab.id_a + "_archivo_nombre"] ??
      cab.archivo_nombre ??
      e.split("/").pop();

    return (
      <a
        id={id_elemento}
        className={`Listado_Switch_Enlace ${cab.className}`}
        href={e}
        rel="noopener noreferrer"
        download={archivo_nombre}
        style={{ width: "min-content" }}
      >
        {renderContenido(cab, data, hijos, "center")}
      </a>
    );
  }

  return (
    <div id={id_elemento} className={`Listado_Switch_Enlace ${cab.className}`}>
      {enlaceConstruido.externo ? (
        <Ancla
          id_elemento={id_elemento}
          cab={cab}
          enlace={enlace}
          data={data}
          hijos={hijos}
          target="_self"
        />
      ) : (
        <Link
          to={{
            pathname:"/"+ enlaceConstruido.enlace,
            search: enlaceConstruido.parametros,
            target: cab.target,
          }}
        >
          {renderContenido(cab, data, hijos, "center")}
        </Link>
      )}
    </div>
  );
};

export default Enlace;

const Ancla = ({ cab, enlace, data, hijos, target, id_elemento }) => {
  return (
    <a
      id={id_elemento}
      className={`Listado_Switch_Enlace ${cab.className}`}
      target={target}
      href={enlace}
      rel="noopener noreferrer"
    >
      {renderContenido(cab, data, hijos, cab.align ?? "left")}
    </a>
  );
};

const renderContenido = (cab, data, hijos, align = "left") => {
  const boton_texto = getAtributo("boton_texto", data, cab);
  return (
    <div style={{ textAlign: align }}>
      {cab.imagen_url ? (
        <img
          style={{ cursor: "pointer" }}
          height={"40px"}
          src={cab.imagen_url}
          alt="imagen"
        />
      ) : (
        <>
          {boton_texto}
        </>
      )}
      {hijos}
    </div>
  );
};
